import { graphql, useFragment } from "react-relay";

import { ItemListItem$key } from "../../../__generated__/ItemListItem.graphql";
import routes from "../../../lib/routes";
import { extractNodes } from "../../../lib/utils/connection";
import GridItem from "../../grid/GridItem";

type ItemListItemProps = {
  item: ItemListItem$key;
};

const fragment = graphql`
  fragment ItemListItem on Item {
    slug
    title @required(action: LOG)

    artist {
      name
    }

    images(first: 1) {
      edges {
        node {
          uri @required(action: LOG)
        }
      }
    }
  }
`;

function ItemListItem(props: ItemListItemProps) {
  const data = useFragment(fragment, props.item);

  if (!data) {
    return null;
  }

  const images = extractNodes(data.images);

  return (
    <GridItem
      href={routes.item(data.slug)}
      title={data.title}
      subtitle={data.artist?.name ?? undefined}
      {...(images.length > 0 ? { imageSrc: images[0].uri } : {})}
    />
  );
}

export default ItemListItem;
